import { Stack, Typography } from '@mui/material';
import { Box, styled } from '@mui/system';

const Label = styled(Typography)({
  fontWeight: 500,
});

const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100vh',
  backgroundColor: theme.palette.background.subtle,
}));

const Wrapper = styled(Stack)(({ theme }) => ({
  height: '100%',
  flexDirection: 'row',
}));

const Left = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  borderImage:
    'repeating-linear-gradient(180deg,#cccccc 0,#cccccc 4px,transparent 0,transparent 8px) 1',
  borderLeft: `1px dashed ${theme.palette.border.default}`,
  borderRight: `1px dashed ${theme.palette.border.default}`,
  width: '50%',
}));

const Right = styled(Box)(({ theme }) => ({
  borderImage:
    'repeating-linear-gradient(180deg,#cccccc 0,#cccccc 4px,transparent 0,transparent 8px) 1',
  borderRight: `1px dashed ${theme.palette.border.default}`,
  flex: 1,
  width: '50%',
}));

const TopAccent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(8),
  backgroundImage: 'url(/static/onboarding/onboarding-blocks-1.svg)',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'bottom right',
  borderBottom: `1px dashed ${theme.palette.border.default}`,
  borderImage:
    'repeating-linear-gradient(90deg,#cccccc 0,#cccccc 4px,transparent 0,transparent 8px) 1',
}));

const BottomAccent = styled(Box)<{ side: 'left' | 'right' }>(({ theme, side }) => ({
  padding: theme.spacing(4),
  backgroundImage:
    side === 'left'
      ? "url('/static/onboarding/onboarding-blocks-3.svg')"
      : "url('/static/onboarding/onboarding-blocks-2.svg')",
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top left',
  borderImage:
    'repeating-linear-gradient(90deg,#cccccc 0,#cccccc 4px,transparent 0,transparent 8px) 1',
  borderTop: `1px dashed ${theme.palette.border.default}`,
  height: '150px',
}));

const Body = styled(Stack)(({ theme }) => ({
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
}));

export { Container, Label, Wrapper, TopAccent, BottomAccent, Body, Left, Right };
